module.exports = __webpack_public_path__ + "img/svg/share.120ff6895f070b9f4f2e13989898518d.svg";